const messages = {
  hello: 'bonjour'
}

export default messages
